import React, { useEffect, useState } from "react";
import ChangePassword from "../../components/ChangePassword";
import LlmUsagePanel from "../../components/admin/LlmUsagePanel";
import { apiFetch } from "../../services/api";
import { useV2Theme } from "../theme/ThemeProvider";

function readStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}") || {};
  } catch {
    return {};
  }
}

/** Prefer explicit has_password; fall back to legacy blobs without the flag. */
function userHasLocalPassword(user) {
  if (!user || typeof user !== "object") return true;
  if (typeof user.has_password === "boolean") return user.has_password;
  // Legacy login payloads may still include password_hash.
  if ("password_hash" in user) return Boolean(user.password_hash);
  return true;
}

const V2SettingsPage = () => {
  const { tokens } = useV2Theme();
  const [user, setUser] = useState(readStoredUser);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await apiFetch("/api/auth/me");
        if (!res.ok || cancelled) return;
        const me = await res.json();
        if (!me || typeof me !== "object" || cancelled) return;
        const { is_demo: _drop, password_hash: _ph, ...safe } = me;
        localStorage.setItem("user", JSON.stringify(safe));
        if (!cancelled) setUser(safe);
      } catch {
        /* keep stored user */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const hasPassword = userHasLocalPassword(user);
  const provider = String(user?.auth_provider || "").trim().toLowerCase();
  const providerLabel =
    provider === "google"
      ? "Google"
      : provider && provider !== "password"
        ? provider.charAt(0).toUpperCase() + provider.slice(1)
        : "your company identity provider";

  return (
    <section className="space-y-4">
      <div className={`${tokens.surface.card} overflow-hidden`}>
        <div className={`${tokens.surface.panelHeader}`}>
          <h3 className="text-base font-semibold text-slate-900">
            {hasPassword ? "Change password" : "Sign-in"}
          </h3>
        </div>
        <div className="border-t border-slate-200 bg-slate-50/50 p-4">
          {hasPassword ? (
            <ChangePassword user={user} variant="embedded" />
          ) : (
            <p className="text-sm text-slate-600 leading-relaxed">
              Sign-in for this account is managed by {providerLabel}. Change your
              password or security settings there — DecisionPen does not store a
              local password for SSO-only accounts.
            </p>
          )}
        </div>
      </div>

      <div className={`${tokens.surface.card} overflow-hidden`}>
        <div className={`${tokens.surface.panelHeader}`}>
          <h3 className="text-base font-semibold text-slate-900">
            LLM usage
          </h3>
        </div>
        <div className="border-t border-slate-200 bg-slate-50/50">
          <LlmUsagePanel hideHeader />
        </div>
      </div>
    </section>
  );
};

export default V2SettingsPage;
